<div class="container">
  <mat-toolbar class="items-aling">
    <span>Productos</span>
    <div class="example-spacer"></div>
    <button mat-raised-button color="accent" name="new" (click)="add()" appPermissionControl="P192B0001"><mat-icon class="icon">add</mat-icon>Nuevo</button>
  </mat-toolbar>
  <div>
    <mat-form-field color="accent" appearance="outline">
      <mat-label>Buscar</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" placeholder="Ej. ALGO..." #input appPermissionControl="P192K0001" />
      <mat-icon matSuffix color="accent">search</mat-icon>
    </mat-form-field>
  </div>
  <div class="mat-elevation-z8 table-responsive">
    <table mat-table [dataSource]="dataSource" class="items-aling" appPermissionControl="P192T0001">
      <ng-container matColumnDef="actions">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0001">Acciones</th>
        <td mat-cell *matCellDef="let element">
          <button mat-icon-button [matMenuTriggerFor]="menu" appPermissionControl="P192B0002">
            <mat-icon>more_vert</mat-icon>
          </button>
          <mat-menu #menu="matMenu">
            <button mat-menu-item (click)="edit(element)" appPermissionControl="P192B0003">
              <mat-icon>edit</mat-icon>
              <span>Editar</span>
            </button>
            <button (click)="delete(element)" mat-menu-item appPermissionControl="P192B0004">
              <mat-icon>delete</mat-icon>
              <span>Eliminar</span>
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container matColumnDef="consecutivo">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0002">Consecutivo</th>
        <td mat-cell *matCellDef="let element">{{ element.consecutivo }}</td>
      </ng-container>

      <ng-container matColumnDef="paquete">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0003">Paquete</th>
        <td mat-cell *matCellDef="let element">{{ element.paquete }}</td>
      </ng-container>

      <ng-container matColumnDef="producto">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0004">Producto</th>
        <td mat-cell *matCellDef="let element">{{ element.producto }}</td>
      </ng-container>

      <ng-container matColumnDef="porcentaje">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0005">%</th>
        <td mat-cell *matCellDef="let element">{{ element.porcentaje }}</td>
      </ng-container>

      <ng-container matColumnDef="tasaMin">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0006">Tasa</th>
        <td mat-cell *matCellDef="let element">{{ element.tasaMin }}</td>
      </ng-container>

      <ng-container matColumnDef="plazoMin">
        <th mat-header-cell *matHeaderCellDef appPermissionControl="P192C0007">Plazo</th>
        <td mat-cell *matCellDef="let element">{{ element.plazoMin }}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="[5, 10, 20, 40, 80]" showFirstLastButtons class="paginatorTb"></mat-paginator>
  </div>
</div>
